import { useState } from "react";
import { Menu, X } from "lucide-react";
import websiteLogo from "../Images/websiteLogo-black.png";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);

    if (element) {
      const top = element.offsetTop - 60;

      window.scrollTo({
        top,
        behavior: "smooth"
      });
    }

    setIsMenuOpen(false);
  };

  const links = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "speakers", label: "Speakers" },
    { id: "artists", label: "Artists" },
    { id: "registration", label: "Register" },
    { id: "contact", label: "Contact" }
  ];

  const buttonStyle = {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "8px 10px",
    borderRadius: "6px"
  };

  return (
    <header
      style={{
        position: "fixed",
        top: 0,
        width: "100%",
        background: "white",
        borderBottom: "1px solid #ddd",
        zIndex: 1000
      }}
    >
      {/* NAVBAR */}
      <nav
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px"
        }}
      >
        {/* LOGO */}
        <img
          src={websiteLogo}
          alt="Logo"
          style={{
            height: "40px",
            objectFit: "contain"
          }}
        />

        {/* DESKTOP MENU */}
        <div
          className="desktop-menu"
          style={{
            display: "flex",
            gap: "10px"
          }}
        >
          {links.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              style={buttonStyle}
              onMouseEnter={(e) => (e.target.style.background = "#f2f2f2")}
              onMouseLeave={(e) => (e.target.style.background = "none")}
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* HAMBURGER (MOBILE) */}
        <button
          className="mobile-menu-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer"
          }}
        >
          {isMenuOpen ? <X /> : <Menu />}
        </button>
      </nav>

      {/* MOBILE MENU PANEL */}
      {isMenuOpen && (
        <div
          style={{
            position: "absolute",
            top: "60px",
            left: 0,
            width: "100%",
            background: "white",
            borderTop: "1px solid #ddd",
            padding: "15px"
          }}
        >
          {links.map((link) => (
            <div key={link.id}>
              <button
                onClick={() => scrollToSection(link.id)}
                style={{
                  width: "100%",
                  textAlign: "left",
                  padding: "12px",
                  border: "none",
                  background: "none",
                  borderBottom: "1px solid #eee",
                  cursor: "pointer"
                }}
              >
                {link.label}
              </button>
            </div>
          ))}
        </div>
      )}

      {/* RESPONSIVE CSS */}
      <style>
        {`
          @media (max-width: 768px) {
            .desktop-menu {
              display: none !important;
            }

            .mobile-menu-btn {
              display: block;
            }
          }

          @media (min-width: 769px) {
            .mobile-menu-btn {
              display: none;
            }
          }
        `}
      </style>
    </header>
  );
}

export default Header;